"use client";
import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import { Flex } from "@chakra-ui/react";
import { Helmet } from "react-helmet";
import Footer from "./Footer";

const LayoutWrapper = ({
  children,
  isPrivate = false,
}: {
  children: React.ReactNode;
  isPrivate: boolean;
}) => {
  const pathname = usePathname();
  const [baseSiteUrl, setBaseSiteUrl] = useState("https://deepmode.com");
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    setBaseSiteUrl(window.location.origin);
  }, []);

  const baseUrl = `${baseSiteUrl}${pathname}`;
  const renderCanonical = !isPrivate;

  return (
    <Flex direction="column" visibility={isMounted ? "visible" : "hidden"}>
      {isMounted && (
        <Helmet>
          {renderCanonical && <link rel="canonical" href={baseUrl} />}
        </Helmet>
      )}
      {children}
      <Footer />
    </Flex>
  );
};

export default LayoutWrapper;